<template>
  <div>
    <content-header
      ref="aa"
      :menuList="menuList"
      :category="currentCategory"
      @catergoryChange="handleCategoryChange"
      @catergoryTab="handleCatergoryTab"
    ></content-header>
    <div class="sky-hc-content__content">
      <div class="sky-hc-content__list" v-if="isArticle">
        <help-img-card v-for="item in list" :key="item.id" :data="item"></help-img-card>
      </div>
      <div class="sky-hc-content__list" v-if="isFile">
        <a
          v-for="(item, index) in list.filter(listItem => listItem.type === FILE_TYPE.PDF)"
          :key="index"
          class="sky-hc-content__download"
          :href="item.url"
          target="help"
          :download="item.title + '.pdf'"
          @click="handeleReport(item)"
        >
          <i class="sky-hc-content__icon sky-hc-content__icon-pdf" />
          <div class="sky-hc-content__download-text-box">
            <el-tooltip :content="item.title" placement="top" :disabled="!item.moreThenOne">
              <div
                class="sky-hc-content__download-text"
                :class="item.moreThenOne ? '' : 'sky-hc-content__download-text--one-line'"
                :ref="'pdfName' + index"
                :morethanOne="item.moreThenOne"
              >
                <span>{{ item.title }}</span>
              </div>
            </el-tooltip>
          </div>
          <div class="sky-hc-content__download-btn-wrapper">
            <i class="sk-icon-overview" /><span>{{ $t('help.preview') }}</span>
          </div>
          <div class="sky-hc-content__download--hot" v-if="item.hot">{{$t('help.hot')}}</div>
        </a>

        <el-card
          class="sky-hc-content__card"
          v-for="(item, index) in list.filter(listItem => listItem.type === FILE_TYPE.QCOW)"
          :key="'0' + index"
          @click.native="handleDownLoad(item)"
        >
          <i
            class="sky-hc-content__card-img"
            :class="item.title.toLowerCase().indexOf('win7') !== -1 ? 'sk-icon-win7' : 'sk-icon-win10'"
          />
          <div class="sky-hc-content__card-type">
            {{ item.title.toLowerCase().indexOf('win7') !== -1 ? 'Windows7' : 'Windows10' }}
          </div>
          <div class="sky-hc-content__card-name">{{ item.title }}</div>
          <div class="sky-hc-content__card-hover">
            <i class="sk-icon-download sky-hc-content__icon-download" /><span>{{ $t('help.downloadImage') }}</span>
          </div>
        </el-card>
        <el-card
          class="sky-hc-content__iso-card"
          v-for="(item, index) in list.filter(listItem => listItem.type === FILE_TYPE.ISO)"
          :key="'00' + index"
          @click.native="handleDownLoadIso(item)"
        >
          <div class="sky-hc-content__iso-card-box">
            <i
              class="sky-hc-content__iso-card-img"
            />
            <tooltip-over class="sky-hc-content__iso-card-txt" placement="top" :content="item.title" />
          </div>
          <span class="sky-hc-content__iso-card-download">{{ $t('help.download') }}</span>
        </el-card>
      </div>
      <no-data v-if="!list.length" class="sky-hc-content__no-data"></no-data>
      <div class="sky-hc-content__page">
        <el-pagination
          background
          layout="prev, pager, next"
          v-if="total > limit"
          :total="total"
          :page-size="limit"
          :current-page="page"
          @current-change="handleSizeChange"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { Pagination, Card, Tooltip } from 'element-ui'


import ContentHeader from '../components/contentHeader'
import HelpImgCard from '../components/helpImgCard'

import NoData from '../components/noData'

import { getHelpArticleList, getHelpFileList, getCategory, reportClick } from '@/api/help'

import TooltipOver from '@/components/tooltipOver'
import { CATEGORY_TYPE, FILE_TYPE } from '@/utils/enum'
export default {
  name: 'Content',
  components: {
    ContentHeader,
    HelpImgCard,
    [Pagination.name]: Pagination,
    [Card.name]: Card,
    NoData,
    [Tooltip.name]: Tooltip,
    TooltipOver
  },
  data() {
    return {
      page: 1,
      limit: 9,
      menuList: [],
      list: [],
      total: 0,
      categoryId: this.$route.query.categoryId,
      categoryName: this.$route.query.categoryName,
      type: this.$route.query.type,
      tab: this.$route.query.tab ? this.$route.query.tab : '0',
      parentCategory: null,
      FILE_TYPE,
      currentCategory: {
        id: '',
        name: ''
      }
    }
  },
  watch: {
    $route() {
      this.categoryId = this.$route.query.categoryId
      this.categoryName = this.$route.query.categoryName
      this.type = this.$route.query.type
      this.tab = this.$route.query.tab ? this.$route.query.tab : '0'
      this.page = 1
      this.list = []
      this.menuList = []
      this.handleGetCategory()
    }
  },
  computed: {
    isArticle() {
      return this.type === CATEGORY_TYPE.ARTICLE
    },
    isFile() {
      return this.type === CATEGORY_TYPE.FILE
    },
    exactMatchArr() {
      let exactMatchArr = []
      if (this.categoryId) {
        exactMatchArr = [
          {
            name: 'categoryId',
            valueArr: [this.categoryId]
          }
        ]
      }
      return exactMatchArr
    }
  },
  created() {
    this.handleGetCategory()
    this.handleGetList()
  },
  methods: {
    handleFileListPerformance() {
      this.$nextTick(() => {
        this.list = this.list.map((item, index) => {
          if (item.type === FILE_TYPE.PDF) {
            const pdfName = this.$refs[`pdfName${index}`] ? this.$refs[`pdfName${index}`][0] : null
            item.moreThenOne = pdfName
              ? pdfName.offsetHeight <= pdfName.getElementsByTagName('span')[0].offsetHeight
              : false
          }
          return item
        })
      })
    },
    handleGetCategory() {
      getCategory({ id: this.categoryId }).then(response => {
        const content = response.data.content
        this.parentCategory = content.parent
        if (!this.parentCategory) {
          this.menuList = content.children
          if (this.isArticle) {
            this.menuList.unshift({
              id: this.categoryId,
              name: this.$t('help.all')
            })
          }
          this.$store.commit('SET_TITLE', this.categoryName)
        } else {
          this.$store.commit('SET_TITLE', this.parentCategory.name)
          this.$route.query.categoryName = this.parentCategory.name
          this.menuList = content.lateralList
          if (this.isArticle) {
            this.menuList.unshift({
              id: this.parentCategory.id,
              name: this.$t('help.all')
            })
          }
        }
        if (this.isArticle) {
          this.currentCategory = {
            id: this.categoryId
          }
        } else {
          this.currentCategory = this.menuList[this.tab ? this.tab : 0]
        }
      })
    },
    handleGetList() {
      if (this.isArticle) {
        this.handleGetArticleList()
      }
      if (this.isFile) {
        this.handleGetFileList()
      }
    },
    handleGetArticleList() {
      getHelpArticleList({
        exactMatchArr: this.exactMatchArr,
        page: this.page - 1,
        limit: this.limit
      }).then(response => {
        this.list = response.data.content.itemArr
        this.total = response.data.content.total
      })
    },
    handleGetFileList() {
      getHelpFileList({
        exactMatchArr: this.exactMatchArr,
        page: this.page - 1,
        limit: this.limit
      }).then(response => {
        this.list = response.data.content.itemArr
        this.list = this.list.map(item => {
          item.moreThenOne = false
          return item
        })
        this.total = response.data.content.total

        this.handleFileListPerformance()
      })
    },
    handleSizeChange(num) {
      this.page = num
      this.handleGetList()
    },
    handleCategoryChange() {
      this.page = 1
      if (this.tab && this.isFile) {
        this.categoryId = this.menuList[this.tab].id
      }
      this.handleGetList()
    },
    handleCatergoryTab({item, index}) {
      this.categoryId = item.id
      const query = {
          ...this.$route.query,
          categoryId: this.categoryId
        }
        if (index !== 'undefined') {
          Object.assign(query, {
            tab: index
          })
        }
      this.$router.push({
        query: query
      })
    },
    handeleReport(item) {
      reportClick({
        resourceId: item.id,
        type: CATEGORY_TYPE.FILE
      })
    },
    handleDownLoad(item) {
      this.handeleReport(item)
      window.location.href = item.url
    },
    handleDownLoadIso(item) {
      window.open(item.url, 'help')
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(hc-content) {
  @include e(content) {
    padding: 0 360px;
    box-sizing: border-box;
    padding-top: 44px;
  }
  @include e(list) {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
  }
  @include e(page) {
    display: flex;
    justify-content: center;
  }
  @include e(download) {
    position: relative;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: row;
    padding: 27px 0px 30px 30px;
    background: #ffffff;
    margin-right: 18px;
    position: relative;
    overflow: hidden;
    width: calc((100% - 36px) / 3);
    margin-bottom: 20px;
    box-shadow: 0px 8px 24px 0px rgba(0, 0, 0, 0.26);
    &:nth-child(3n) {
      margin-right: 0px;
    }

    @include m(hot){
      position: absolute;
      width: 120px;
      line-height: 24px;
      background:#D0021B ;
      transform: rotate(45deg);
      text-align: center;
      color:#ffffff;
      right: -38px;
      top: 10px;
      font-size: $--font-size-middle;
    }
  }
  @include e(icon) {
    width: 45px;
    height: 52px;
    margin-right: 20px;
    flex-shrink: 0;
    background-repeat: no-repeat;
    background-size: cover;
  }
  @include e(icon-pdf) {
    background-image: url('../../../assets/styles/css_images/help/pdf.svg');
  }
  @include e(download-text-box) {
    flex: 1;
    height: 54px;
    border-right: 1px solid $--color-grey-6;
    padding-top: 3px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }
  @include e(download-text) {
    color: $--color-grey-8;
    font-size: $--font-size-large;
    flex: 1;
    width: 100%;
    height: 48px;
    line-height: 24px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    word-break: break-all;
    padding-right: 30px;
    @include m(one-line) {
      display: flex;
      align-items: center;
    }
  }
  @include e(download-btn-wrapper) {
    display: flex;
    flex-direction: column;
    color: $--color-grey-8;
    align-items: center;
    justify-content: center;
    padding-left: 42px;
    padding-right: 42px;
    flex-shrink: 0;
    & > span {
      font-size: $--font-size-middle;
    }
  }

  @include e(card) {
    width: 388px;
    height: 258px;
    margin-right: 18px;
    text-align: center;
    position: relative;
    cursor: pointer;
    margin-bottom: 20px;
    &:nth-child(3n) {
      margin-right: 0px;
    }
  }
  @include e(card-img) {
    display: block;
    width: 82px;
    height: 82px;
    margin: 0 auto;
    background-size: 100% 100%;
    margin-top: 30px;
    font-size: 82px;
    color: $--color-primary;
  }
  @include e(card-type) {
    color: $--color-grey-8;
    font-size: $--size-base;
    margin-top: 10px;
  }
  @include e(card-name) {
    color: $--color-grey-8;
    font-size: $--font-size-large;
    font-weight: 500;
    line-height: 22px;
    margin-top: 20px;
  }
  @include e(card-hover) {
    width: 388px;
    height: 55px;
    background: $--color-grey-7;
    font-size: $--size-base;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    bottom: -55px;
    left: 0;
    transition: 0.3s ease-in-out;
  }
  @include e(icon-download) {
    font-size: $--font-size-large;
    margin-right: 5px;
  }
  @include e(no-data) {
    margin-top: 30px;
  }
  @include e(page) {
    padding-bottom: 20px;
  }
  @include e(iso-card){
    width: 100%;
    cursor: pointer;
    margin-bottom: 24px;
    &.el-card.is-always-shadow{
      box-shadow: 0px 0px 8px 4px rgba(0, 0, 0, 0.1);
    }
  }
  @include e(iso-card-box){
    display: flex;
    align-items: center;
    flex: 1;
  }
  @include e(iso-card-img){
    display: inline-block;
    width: 44px;
    height: 52px;
    margin-right: 20px;
    flex-shrink: 0px;
    background-size: 100% 100%;
    background-image: image-set(
      url('../../../assets/styles/css_images/help/iso.png') 1x,
        url('../../../assets/styles/css_images/help/iso@2x.png') 2x
    );
  }
  @include e(iso-card-download){
    display: flex;
    align-items: center;
    font-size: 18px;
    line-height: 22px;
    color: $--color-primary;
    cursor: pointer;
    flex-shrink: 0;
    width: fit-content;
  }
  @include e(iso-card-txt){
    flex: 1;
    font-size: 18px;
    color: $--color-grey-8;
  }
}
</style>
<style lang="scss">
.sky-hc-content__card{
  &.el-card.is-always-shadow{
    box-shadow: 0px 0px 8px 4px rgba(0, 0, 0, 0.1);
  }
}
.sky-hc-content__card:hover .sky-hc-content__card-hover {
  bottom: 0px;
}
.sk-icon-overview {
  margin-bottom: 6px;
  font-size: $--font-size-x-large;
}
// .sky-hc-content__list {
//   .sky-hc-img-card {
//     &:nth-child(4n) {
//       margin-right: 0px;
//     }
//   }
// }
// @media (max-width: 1400px) {
//   .sky-hc-content__download:nth-of-type(3n) {
//     margin-right: 18px;
//   }
// }
.sky-hc-content__iso-card{
  .el-card__body{
    display: flex;
    width: 100%;
    justify-content: space-between;
    padding: 33px 48px 33px 35px;
  }
}

</style>
